import React from 'react';
import styled from 'styled-components';
import TEST_ID from './index.testid';
import FakeColumn from './components/FakeColumn';
import FakeRow from './components/FakeRow';

export type Props = {
  rowAmount: number;
  getTableBodyProps: () => Record<string, unknown>;
};

const LoadingBody: React.FCC<Props> = ({ rowAmount, getTableBodyProps }) => {
  const fakeRows = Array(rowAmount || 10).fill({});

  return (
    <Container {...getTableBodyProps()} data-testid={TEST_ID.LOADING_BODY}>
      {fakeRows.map((_, rowIndex) => (
        <FakeRow key={rowIndex}>
          <FakeColumn />
        </FakeRow>
      ))}
    </Container>
  );
};

const Container = styled.div<{}>`
  flex-grow: 1;
  align-self: start;
`;

export default LoadingBody;
